module.exports = __webpack_public_path__ + "img/slide3.51d6849d.jpg";